import styled from 'styled-components'

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`

export const Mailbox = styled.div`
  flex: 1;
`

export const Domain = styled.div`
  flex: 1.2;
`
